import { Injectable } from "@angular/core";
import { HttpClient, HttpBackend } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ParametresAzureDto, ParametresGoogleDto, ParametresServicesDto } from "src/api/models";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private azureSettings: ParametresAzureDto;
  private googleSettings: ParametresGoogleDto;  
  private http: HttpClient;
  constructor(
    private readonly httpHandler: HttpBackend,
  ) {
    this.http = new HttpClient(httpHandler);
  }

  init(endpoint: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.http.get(endpoint + '/api/panel/params/services').pipe(map(res => res))
        .subscribe( (value: ParametresServicesDto)  => {
          this.azureSettings = value.Azure;
          this.googleSettings = value.Google;
          resolve(true);
        },
        (error) => {
          reject(error);
        });
    });
  }

  getAzureSettings(): ParametresAzureDto {
    return this.azureSettings;
  }

  getGoogleSettings() : ParametresGoogleDto {
    return this.googleSettings;
  }
}
